import { createFileRoute } from '@tanstack/react-router';
import messages from 'app/_authenticated/funds/messages';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { BankWithdrawDetailsComponent } from './components/BankWithdrawDetails';

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review',
)({
  component: BankWithdrawDetails,
});

function BankWithdrawDetails() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const { withdrawProductData } = useSelector(
    (rootState: RootState) => rootState.funds,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/withdraw/fiat/${withdrawProductData.code}/bank-details/review`}
      />
      <div className="px-6 py-4">
        <BankWithdrawDetailsComponent />
      </div>
    </>
  );
}
